import axios from 'axios';

export default {
  validatePromocode(code) {
    return axios.post('/api/promo/validate', { code });
  },
};
